import React from "react";
import PropTypes from "prop-types";
import {
  Box,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from "@mui/material";
import { SectionHeading } from "../Common/Typography/AppTypography";
import { buildComparisonRows } from "../../utils/smartRoomHelpers";
import { formatDisplayValue } from "../../utils/smartRoomStatusRanges";

const ComparisonSection = ({ indoor, outdoor }) => {
  const rows = buildComparisonRows(indoor, outdoor);

  return (
    <Box sx={{ mb: 3 }}>
      <SectionHeading sx={{ mb: 0.5 }}>Indoor vs Outdoor</SectionHeading>
      <Typography variant="body2" color="text.secondary" sx={{ mb: 1.5 }}>
        Compare indoor space conditions with outdoor weather for the selected
        space. Outdoor AQI is estimated from outdoor PM2.5 when the weather API
        does not return AQI.
      </Typography>

      <TableContainer
        component={Paper}
        variant="outlined"
        sx={{ borderRadius: 2, overflowX: "auto" }}
      >
        <Table size="small" sx={{ minWidth: 560 }}>
          <TableHead>
            <TableRow sx={{ bgcolor: "action.hover" }}>
              <TableCell sx={{ fontWeight: 700 }}>Parameter</TableCell>
              <TableCell sx={{ fontWeight: 700, bgcolor: "#E8F5E9", color: "success.dark" }}>
                Indoor
              </TableCell>
              <TableCell sx={{ fontWeight: 700 }}>Outdoor</TableCell>
              <TableCell sx={{ fontWeight: 700 }}>Difference</TableCell>
              <TableCell sx={{ fontWeight: 700 }}>Trend</TableCell>
              <TableCell sx={{ fontWeight: 700 }}>Status</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {rows.map((row) => (
              <TableRow key={row.label} hover>
                <TableCell sx={{ fontWeight: 600 }}>{row.label}</TableCell>
                <TableCell
                  sx={{
                    fontWeight: 800,
                    fontSize: "1rem",
                    bgcolor: "rgba(46, 125, 50, 0.06)",
                  }}
                >
                  {formatDisplayValue(row.indoorValue)}
                  {row.unit ? ` ${row.unit}` : ""}
                </TableCell>
                <TableCell sx={{ color: "text.secondary", fontWeight: 600 }}>
                  {formatDisplayValue(row.outdoorValue)}
                  {row.unit ? ` ${row.unit}` : ""}
                </TableCell>
                <TableCell>
                  {row.difference == null
                    ? "—"
                    : `${row.difference > 0 ? "+" : ""}${row.difference}${
                        row.unit ? ` ${row.unit}` : ""
                      }`}
                </TableCell>
                <TableCell
                  sx={{
                    fontWeight: 700,
                    fontSize: "1.1rem",
                    color:
                      row.arrow === "↑"
                        ? "warning.main"
                        : row.arrow === "↓"
                        ? "success.main"
                        : "text.secondary",
                  }}
                >
                  {row.arrow}
                </TableCell>
                <TableCell>{row.status}</TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </Box>
  );
};

ComparisonSection.propTypes = {
  indoor: PropTypes.object,
  outdoor: PropTypes.object,
};

export default ComparisonSection;
